/* eslint-disable no-nested-ternary */
import React from 'react';
import styled from 'styled-components';
import { LinkedInPost, Tweet } from 'Types/ArticleTypes';
import { useLocation, useNavigate } from 'react-router-dom';
import { COMPANY, FEED, GROUPDETAILS } from 'Utils/Constants';
import {
  primaryColor, primaryFont, secondaryFont, wLight, wMBold, maxWidth, retina, wMedium,
} from '../../../Utils/utilsStyle';
import IconButton from './IconButton';
import LinkedInIcon from '../assets/svgIcons/LinkedInIcon';
import TwitterIcon from '../assets/svgIcons/TwitterIcon';

type Props = {
  personName?: string;
  retweet?: boolean;
  tweetData?: Tweet;
  SocialType: string;
  linkedInData?: LinkedInPost;
  companyId?: number;
  companyName?: string;
} & typeof defaultProps;

const defaultProps = {
  personName: '',
  retweet: false,
  tweetData: {},
  linkedInData: {},
  companyId: 0,
  companyName: '',
};

const Wrapper = styled.div`
  .ant-icon-button {
    box-shadow: none;
  }
  .mainPersonName {
    font-size: 14px;
    color: #1C2022;
    font-weight:${wMBold};
    font-family: ${primaryFont};
    margin: 0;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 12px;
    }
  }
  .reTweetPersonName {
    font-size: 14px;
    color: #1C2022;
    font-weight: ${wMBold};
    font-family: ${primaryFont};
    margin: 0;
    span{
      color: #697882;
      font-weight: ${wLight};
    }
  }
  .reTweetPersonTweetText {
    font-weight: ${wLight} !important;
  }
  p {
    font-size: 16px;
    color: #7E7E7E !important;
    font-weight: ${wLight};
    font-family: ${primaryColor};
    letter-spacing: -0.75px;
  }
  .peopleWidget {
    margin-right: 13px;
  }
  .social_account_executive{
    display: inline-flex;
    align-items: center;
    .social_account_pipe{
      margin: 0 8px;
    }
    button{
      padding: 0;
    }
  }
  .social_account_company, .social_account_executive{
    button{
      svg{
        display: none;
      }
      span{
        padding: 0px;
      }
    }
  }
  .person_designation{
      line-height: 14.5px;
      font-size: 12px;
      font-weight: ${wMedium};
      font-family: ${primaryFont};
      color: #7E7E7E;
  }
  .person_company{
      margin: 3px 0;
      line-height: 14.5px;
      font-size: 12px;
      font-weight: ${wMedium};
      font-family: ${primaryFont};
      color: ${primaryColor};
  }
  .dividerOfRetweet {
    height: 23px;
    border: 0.5px solid #CCD6DD;
    margin-top: 3px;
  }
  .to-person-name {
    font-family: ${secondaryFont};
    font-size: 14px;
    font-weight: ${wLight};
    color: #697882;
    padding-bottom: 10px;
  }
  .article-item {
    cursor: unset;
  }
`;

const ImageSmall = styled.div<{ image: string }>`
 width: 24px;
 height: 24px;
 border-radius: 50%;
 background-image: url(${(props) => props.image});
 background-position:center;
 background-size:cover;
`;

const Image = styled.div<{ image: string }>`
 width: 36px;
 height: 36px;
 border-radius: 50%;
 background-image: url(${(props) => props.image});
 background-position:center;
 background-size:cover;
`;

const UserSocialInfoCard = function UserSocialInfoCard(props: Props) {
  const {
    personName,
    retweet,
    tweetData,
    SocialType,
    linkedInData,
    companyId,
    companyName,
  } = props;

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const reDirectSocialMedia = (e: React.MouseEvent<HTMLButtonElement>, about = false) => {
    e.stopPropagation();
    const urlLink = SocialType.toLowerCase() === 'tweet'
      ? about ? `https://twitter.com/${tweetData.aboutTwitterAccountDetails?.handler}`
        : `https://twitter.com/${tweetData.byTwitterAccountDetails?.handler}`
      : linkedInData.posterUrl;
    window.open(urlLink);
  };

  const openProfile = (
    e: React.MouseEvent<HTMLSpanElement, MouseEvent> | React.KeyboardEvent<HTMLSpanElement>,
  ) => {
    e.stopPropagation();
    let openProfileLink = '';
    if (companyId !== 0) {
      openProfileLink = `/company/overview?companyId=${companyId}`;
    } else {
      openProfileLink = SocialType.toLowerCase() === 'linkedIn'
        ? linkedInData.id ? `/person/personalityinsights?personId=${linkedInData.id}&personType=EXECUTIVE`
          : ''
        : tweetData.byTwitterAccountDetails.id ? `/person/personalityinsights?personId=${tweetData.byTwitterAccountDetails.id}&personType=EXECUTIVE`
          : '';
    }
    if (openProfileLink !== '') {
      window.scrollTo(0, 0);
      navigate(openProfileLink);
    }
  };

  const aboutProfile = (
    e: React.MouseEvent<HTMLSpanElement, MouseEvent> | React.KeyboardEvent<HTMLSpanElement>,
  ) => {
    e.stopPropagation();
    navigate(`/person/personalityinsights?personId=${tweetData.aboutTwitterAccountDetails.id}&personType=EXECUTIVE`);
  };

  const pathIncludes = () => pathname.includes(`${FEED}/`) || pathname.includes(`${COMPANY}/`) || pathname.includes(`${GROUPDETAILS}/`);
  console.log(personName);
  return (
    <Wrapper>
      <div className="d-flex justify-content-between align-items-start">
        <div>
          {
            retweet ? (
              <div
                className="d-flex align-items-start"
                style={{
                  paddingLeft: '6px',
                }}
              >
                <div
                  className="peopleWidget d-flex align-items-center"
                  style={{
                    flexDirection: 'column',
                  }}
                >
                  <ImageSmall
                    image={tweetData?.aboutTwitterAccountDetails?.profilePic}
                    onClick={(e) => aboutProfile(e)}
                    onKeyPress={(e) => aboutProfile(e)}
                    role="button"
                    aria-label="View profile"
                    tabIndex={0}
                  />
                  <div className="dividerOfRetweet" />
                </div>
                <div>
                  <span
                    onClick={(e) => aboutProfile(e)}
                    onKeyPress={(e) => aboutProfile(e)}
                    role="button"
                    aria-label={tweetData?.aboutTwitterAccountDetails?.name}
                    tabIndex={0}
                  >
                    <h5 className="primary-color text-start reTweetPersonName">
                      {tweetData?.aboutTwitterAccountDetails?.name}
                    </h5>
                  </span>
                  <div
                    className="d-flex align-items-center to-person-name"
                  >
                    {tweetData?.aboutTwitterAccountDetails?.designation}
                  </div>
                </div>
              </div>
            ) : null
          }
          <div
            className="d-flex align-items-center"
          >
            {
              SocialType.toLowerCase() === 'linkedin' && linkedInData?.profilePic !== ''
                ? (
                  <div
                    className="peopleWidget d-flex align-items-center"
                    onClick={(e) => openProfile(e)}
                    onKeyPress={(e) => openProfile(e)}
                    role="button"
                    aria-label="Open profile"
                    tabIndex={0}
                  >
                    <Image image={linkedInData?.profilePic} />
                  </div>
                )
                : SocialType === 'tweet' && tweetData?.byTwitterAccountDetails?.profilePic !== ''
                  ? (
                    <div
                      className="peopleWidget d-flex align-items-center"
                      onClick={(e) => openProfile(e)}
                      onKeyPress={(e) => openProfile(e)}
                      role="button"
                      aria-label="open profile"
                      tabIndex={0}
                    >
                      <Image image={tweetData?.byTwitterAccountDetails?.profilePic} />
                    </div>
                  )
                  : ''
            }

            <div>
              <div className={companyId || !pathIncludes() ? 'social_account_company' : 'social_account_executive'}>
                {SocialType.toLowerCase() === 'linkedin' && linkedInData?.name !== '' ? (
                  <span
                    onClick={(e) => openProfile(e)}
                    onKeyPress={(e) => openProfile(e)}
                    role="button"
                    aria-label="Open Profile"
                    tabIndex={0}
                  >
                    <h5 className="primary-color text-start mainPersonName">
                      {linkedInData?.name}
                    </h5>
                  </span>

                ) : SocialType.toLowerCase() === 'tweet' && tweetData?.byTwitterAccountDetails?.name !== ''
                  ? (
                    <span
                      onClick={retweet ? (e) => e.stopPropagation() : (e) => openProfile(e)}
                      onKeyPress={retweet ? (e) => e.stopPropagation() : (e) => openProfile(e)}
                      role="button"
                      tabIndex={0}
                    >
                      <h5 className="primary-color text-start mainPersonName">
                        {tweetData?.byTwitterAccountDetails?.name}
                      </h5>
                    </span>
                  ) : null}
                {companyId || !pathIncludes() ? null : <span className="social_account_pipe">{'  |  '}</span>}
                {tweetData?.byTwitterAccountDetails?.handler !== '' && SocialType.toLowerCase() === 'tweet'
                  ? (
                    <div
                      className="social_account d-flex align-items-center"
                    >
                      <IconButton
                        onButtonClick={(e) => reDirectSocialMedia(e, false)}
                        Icon={SocialType === 'tweet' ? TwitterIcon : LinkedInIcon}
                        title={`@${tweetData?.byTwitterAccountDetails?.handler}`}
                      />
                    </div>
                  )
                  : linkedInData?.handler !== '' && SocialType.toLowerCase() === 'linkedin'
                    ? (
                      <div
                        className="social_account d-flex align-items-center"
                      >
                        <IconButton
                          onButtonClick={(e) => reDirectSocialMedia(e, false)}
                          Icon={SocialType.toLowerCase() === 'linkedin' ? LinkedInIcon : TwitterIcon}
                          title={`@${linkedInData?.handler}`}
                        />
                      </div>
                    ) : null}

              </div>
              {companyId || !pathIncludes() ? null
                : (
                  <>
                    <div className="person_designation">
                      {SocialType.toLowerCase() === 'tweet'
                        ? tweetData?.byTwitterAccountDetails?.designation || ''
                        : linkedInData?.designation || ''}
                    </div>
                    <div className="person_company">
                      {SocialType.toLowerCase() === 'tweet'
                        ? tweetData?.byTwitterAccountDetails?.companyName || companyName || ''
                        : linkedInData?.companyName || ''}
                    </div>
                  </>
                )}
            </div>
          </div>
        </div>
        <div>
          <IconButton
            onButtonClick={(e) => reDirectSocialMedia(e, retweet)}
            Icon={SocialType === 'tweet' ? TwitterIcon : LinkedInIcon}
          />
        </div>
      </div>
    </Wrapper>
  );
};

UserSocialInfoCard.defaultProps = defaultProps;

export default UserSocialInfoCard;
